import { useState, useEffect, createRef } from 'react'
import { noop } from '../../utils/function'

const useListRefs = (length) => {
  const arrLength = length

  const [elRefs, setElRefs] = useState([])

  useEffect(() => {
    setElRefs((elRefs) =>
      Array(arrLength)
        .fill()
        .map((_, i) => elRefs[i] || createRef())
    )
  }, [arrLength])

  return elRefs
}

const animatedScrollTo = (scroll0, scrollGoal, onUpdate = noop, onFinish = noop) => {
  let now0 = null

  const maxScrollDelta = Math.max(scrollGoal, scroll0) - Math.min(scrollGoal, scroll0)
  const reverse = scrollGoal < scroll0
  const duration = 300

  const step = (now) => {
    if (now0 === null) now0 = now
    const t = now - now0
    const scrollDelta = maxScrollDelta * Math.sin(((Math.PI / 2) * t) / duration)
    const scrollPos = reverse ? scroll0 - scrollDelta : scroll0 + scrollDelta
    if (t < duration) {
      onUpdate(scrollPos)
      requestAnimationFrame(step)
    } else {
      onUpdate(scrollGoal)
      onFinish()
    }
  }

  requestAnimationFrame(step)
}

const useScrollToTargetItem = (scrollableContainerRef, listElementsRefsToScroll, targetScrollElementIndex) => {
  useEffect(() => {
    if (scrollableContainerRef.current && Boolean(listElementsRefsToScroll?.[targetScrollElementIndex]?.current)) {
      animatedScrollTo(
        scrollableContainerRef?.current?.scrollLeft ?? 0,
        listElementsRefsToScroll[targetScrollElementIndex].current.offsetLeft,
        (currentScrollPosition) => {
          if (scrollableContainerRef?.current) {
            scrollableContainerRef.current.scrollLeft = currentScrollPosition
          }
        }
      )
    }
  }, [targetScrollElementIndex, listElementsRefsToScroll, scrollableContainerRef])
}

export const useScrollableList = (size, scrollableContainerRef, targetScrollElementIndex) => {
  const listElementsRefsToScroll = useListRefs(size)

  useScrollToTargetItem(scrollableContainerRef, listElementsRefsToScroll, targetScrollElementIndex)

  return listElementsRefsToScroll
}
